<template>
  <div>
    <div v-if="!isQuerySuccess" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
      <table class="report-table">
        <thead>
          <tr>
            <th>{{ $t('Date') }}</th>
            <th class="center-text">{{ $t('CONTACT NAME') }}</th>
            <th class="center-text">{{ $t('AGENT NAME') }}</th>
            <th>{{ $t('INBOX NAME') }}</th>
            <th class="center-text">{{ $t('CONVERSATION ID') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in paginatedData" :key="index" @click="openMessageModal(row)">
            <td>{{ formatDate(row.resolved_date) }}</td>
            <td class="center-text">{{ row.contact_name }}</td>
            <td class="center-text">{{ selectedFilter.name }}</td>
            <td>{{ row.inbox_name }}</td>
            <td class="center-text">{{ row.conversation_ref }}</td>
          </tr>
        </tbody>
      </table>
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">
          <span>&larr;</span> Previous
        </button>
        <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage === totalPages">
          Next <span>&rarr;</span>
        </button>
      </div>
    </div>

    <MessageModal
      v-if="isModalOpen"
      :modalData="modalData"
      @close="closeModal"
    />
  </div>
</template>

<script>
import MessageModal from './MessageModal.vue';
import { parseISO, addHours, format } from 'date-fns';

export default {
  components: {
    MessageModal,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    selectedFilter: {
      type: Object,
      required: true,
    },
    isQuerySuccess: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
      modalData: {},
      currentPage: 1,
      rowsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.tableData.length / this.rowsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.tableData.slice(start, end);
    },
  },
  methods: {
    formatDate(utcDate) {
      const date = parseISO(utcDate);
      const dateInUTC7 = addHours(date, 7);
      return format(dateInUTC7, 'dd/MM/yyyy HH:mm:ss');
    },
    openMessageModal(row) {
      this.modalData = {
        contact_name: row.contact_name,
        agent_name: this.selectedFilter.name,
        messages: row.prev_content.match(/(user|admin):\s*(.*?)(?=(user|admin):|$)|[^:]+/g).map(msg => {
          if (msg.startsWith('user:') || msg.startsWith('admin:')) {
            const [sender, text] = msg.split(':');
            return { sender: sender.trim(), text: text.trim() };
          } else {
            return { sender: 'system', text: msg.trim() };
          }
        }),
        date: row.resolved_date,
      };
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
  },
};
</script>

<style scoped>
.report-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  border: 1px solid #ccc;
}

.report-table th, .report-table td {
  padding: 8px;
  text-align: left;
  font-size: 14px;
}

.report-table th {
  background-color: #f4f4f4;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.pagination button {
  margin: 0 10px;
  padding: 10px 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: grey;
  background: none;
  border: 1px solid grey;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button span {
  margin: 0 5px;
  font-size: 18px;
  color: grey;
}

.page-info {
  font-size: 16px;
  margin: 0 10px;
  color: grey;
}

.report-table tr {
  border-bottom: 1px solid #ccc;
}

.center-text {
  text-align: center;
}

th.center-text, td.center-text {
  text-align: center;
}
</style>
